/* eslint-disable no-unused-vars */
// Core & Vendor Packages
import React, { useState } from 'react';
import { Navbar, Container, Offcanvas, Nav, NavDropdown, Form, Button } from 'react-bootstrap';

// Components
import ReactHelmet from './ReactHelmet';
import Footer from 'components/Layouts/Footer';
import NavBar from 'components/Layouts/NavBar';

// Assets
import 'components/Styles/PrivateLayout.scss';

const PrivateLayout = ({ children, pageTitle }) => {
  return (
    <>
      <ReactHelmet title={pageTitle} />

      <div className='navigation-bar'>
        <NavBar />

        <div className='main-container'>{children}</div>

        <Footer />
      </div>
    </>
  );
};

export default PrivateLayout;
